import { type DefaultRole } from '../types'
import { DEFAULT_COMPANY_ADMIN } from './admin'
import { DEFAULT_TEAM_MANAGER } from './manager'
import { DEFAULT_USER } from './user'

export const DEFAULT_ROLES: DefaultRole[] = [DEFAULT_USER, DEFAULT_TEAM_MANAGER, DEFAULT_COMPANY_ADMIN]
